export default {
  styleOverrides: {
    tooltip: {
      backgroundColor: 'var(--color-text-primary)',
      color: 'var(--color-bg-paper)',
      fontSize: '0.75rem',
      padding: '8px 12px',
      borderRadius: '6px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },

    arrow: {
      color: 'var(--color-text-primary)',
    },
  },
};
